<template>
  <v-col :cols="12" :sm="12" :md="12">
    <v-alert
      transition="scroll-y-transition"
      type="success"
      v-show="mensagemSucesso"
      @click="fecharNotificacao"
      >Perfil atualizado com sucesso!</v-alert
    >
    <v-container grid-list-md>
      <v-progress-linear
        :active="isLoadingRequestDisable"
        indeterminate
        color="green accent-4"
        height="7"
      ></v-progress-linear>
      <v-form>
        <v-col cols="12">
          <v-container grid-list-md>
            <v-row>
              <v-col cols="3" class="text-center">
                <v-col cols="12">
                  <v-avatar color="grey lighten-2" size="200">
                    <img v-bind:src="displayImage" />
                  </v-avatar>
                </v-col>

                <v-col cols="12">
                  <v-file-input
                    prepend-icon="mdi-camera"
                    placeholder="Alterar foto"
                    accept="image/*"
                    @change="changeProfilePic"
                  >
                  </v-file-input>
                </v-col>
              </v-col>

              <v-col cols="9">
                <v-col cols="12">
                  <v-text-field
                    v-model="actualEdit.nomeUsuario"
                    name="nomeUsuario"
                    label="Nome Usuário"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="actualEdit.emailUsuario"
                    name="emailUsuario"
                    label="Email do Usuário"
                  ></v-text-field>
                </v-col>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="text-left">
                <span>
                  <b>Dados Pessoais:</b>
                </span>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  v-model="actualEdit.cpfUsuario"
                  name="cpfUsuario"
                  label="CPF"
                  v-mask="['###.###.###-##', '##.###.###/####-##']"
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  v-model="actualEdit.telefoneUsuario"
                  name="telefoneUsuario"
                  label="Telefone"
                  v-mask="['(##)#####-####']"
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  v-model="actualEdit.cargoUsuario"
                  name="cargoUsuario"
                  label="Cargo"
                  readonly
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  v-model="actualEdit.nivelUsuario"
                  name="nivelUsuario"
                  label="Nivel de Acesso"
                  readonly
                ></v-text-field>
              </v-col>

              <v-col cols="12" class="text-left">
                <v-btn
                  color="blue darken-1"
                  text
                  small
                  @click="openModalChangePassword"
                >
                  Alterar Senha?
                </v-btn>
              </v-col>

              <v-col cols="12" class="text-right">
                <v-btn color="success" class="mr-0" @click="updateProfileUser">
                  Editar Perfil
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-form>
    </v-container>

    <ModalCustomSize
      :isTheModalOpen="modalCustomSize.isOpen"
      :modalButtonText="modalCustomSize.buttonText"
      :modalFormTitle="modalCustomSize.formTitle"
      :modalType="modalCustomSize.modalType"
      :modalSize="modalCustomSize.size"
      :isModalButtonVisible="modalCustomSize.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSize.isButtonsDisabled"
      v-on:formmodal-close="fecharModalPassword"
      v-on:formmodal-action="updatePasswordUser"
    >
      <v-alert
        transition="scale-transition"
        type="error"
        text
        v-show="mensagemErro.erro"
        >{{ mensagemErro.text }}</v-alert
      >

      <v-row>
        <v-col cols="12" class="text-left">
          <span> Por favor insira sua senha atual para poder continuar: </span>
        </v-col>
        <v-col cols="12">
          <v-text-field
            :append-icon="showSenhaAntiga ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showSenhaAntiga ? 'text' : 'password'"
            v-model="senhaAntiga"
            name="senhaAntiga"
            label="Senha atual"
            @click:append="showSenhaAntiga = !showSenhaAntiga"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row v-if="showNewPasswordInput">
        <v-col cols="12" class="text-left">
          <span> Agora insira sua nova senha e depois confirme-a: </span>
        </v-col>
        <v-col cols="6">
          <v-text-field
            :append-icon="showDigitarSenha ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showDigitarSenha ? 'text' : 'password'"
            v-model="digitarSenha"
            name="senhaNova"
            label="Nova senha"
            :rules="[required('senha'), minLength(3)]"
            @click:append="showDigitarSenha = !showDigitarSenha"
          ></v-text-field>
        </v-col>

        <v-col cols="6">
          <v-text-field
            :append-icon="showDigitarSenhaNovamente ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showDigitarSenhaNovamente ? 'text' : 'password'"
            v-model="digitarSenhaNovamente"
            name="senhaNova"
            label="Confirmar senha"
            :disabled="digitarSenha == null ? true : false"
            :rules="[required('senha'), minLength(3)]"
            @click:append="
              showDigitarSenhaNovamente = !showDigitarSenhaNovamente
            "
          ></v-text-field>
        </v-col>
      </v-row>
    </ModalCustomSize>
  </v-col>
</template>

<script>
import axios from "../plugins/axios";
import store from "@/store/index";
import ModalCustomSize from "../components/ModalCustomSize";
import validation from "@/utils/validation";

export default {
  components: {
    ModalCustomSize,
  },

  data: () => ({
    mensagemErro: {
      erro: false,
      text: null,
    },

    displayImage: null,
    mensagemSucesso: false,
    ...validation,
    isLoadingRequestDisable: false,

    actualEdit: {
      imgB64Usuario: null,
      numeroFuncionario: null,
      nomeUsuario: null,
      emailUsuario: null,
      cpfUsuario: null,
      telefoneUsuario: null,
      cargoUsuario: null,
      nivelUsuario: null,
      newImage: null,
    },

    modalCustomSize: {
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      size: "1080",
      isButtonsVisible: true,
      isButtonsDisabled: true,
      newPassword: {
        novaSenha: null,
      },
    },

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    senhaAntiga: null,
    digitarSenha: null,
    digitarSenhaNovamente: null,

    showSenhaAntiga: false,
    showDigitarSenha: false,
    showDigitarSenhaNovamente: false,

    showNewPasswordInput: false,
  }),

  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      try {
        this.returnAllProfileData();
      } catch (error) {
        console.log(error);
      }
    },

    async returnAllProfileData() {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": store.state.token,
        },
      };

      const tokenUser = { token: store.state.token };
      const infoUser = await axios.post("/infoProfile", tokenUser, config);

      this.actualEdit.numeroFuncionario = infoUser.data.numeroFuncionario;
      this.modalCustomSize.numeroFuncionario = infoUser.data.numeroFuncionario;
      this.actualEdit.nomeUsuario = infoUser.data.nomeFuncionario;
      this.actualEdit.emailUsuario = infoUser.data.emailFuncionario;
      this.actualEdit.cpfUsuario = infoUser.data.cpfFuncionario;
      this.actualEdit.telefoneUsuario = infoUser.data.telefoneFuncionario;
      this.actualEdit.cargoUsuario = infoUser.data.cargoFuncionario;
      this.actualEdit.imgB64Usuario = "data:image/png;base64," + infoUser.data.urlFotoFuncionario;
      this.displayImage = this.actualEdit.imgB64Usuario;

      if (infoUser.data.indicadorNivelAcesso == 3) {
        this.actualEdit.nivelUsuario = "Usuário do Almoxarifado";
      } else if (infoUser.data.indicadorNivelAcesso == 2) {
        this.actualEdit.nivelUsuario = "Usuário da Unidade";
      } else {
        this.actualEdit.nivelUsuario = "Admin";
      }
    },

    async validatePasswordFromFuncionario(senhaAntiga) {
      try {
        let validations = {
          descricaoSenha: senhaAntiga,
          numeroFuncionario: this.actualEdit.numeroFuncionario,
        };

        let validate = await axios.put("/validatePassword", validations, this.config);

        if (validate.data) {
          this.mensagemErro.erro = false;
          this.showNewPasswordInput = true;
        } else {
          this.mensagemErro.erro = true;
          this.showNewPasswordInput = false;
          this.mensagemErro.text = "Senha incorreta!";
        }
      } catch (error) {
        console.log(error);
      }
    },

    async updateProfileUser() {
      try {
        this.isLoadingRequestDisable = true;
        await axios.put("updateProfile", this.actualEdit, this.config);
        this.initialize();
        this.mensagemSucesso = true;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadingRequestDisable = false;
      }
    },

    async updatePasswordUser() {
      try {
        let newPasswordChanges = {
          novaSenhaFuncionario: this.modalCustomSize.newPassword.novaSenha,
          numeroFuncionario: this.actualEdit.numeroFuncionario,
        };

        await axios.put("changePassword", newPasswordChanges, this.config);
        this.$store.dispatch("logout");
        this.$router.push("/login");
      } catch (error) {
        console.log(error);
      }
    },

    changeProfilePic(image) {
      var reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = () => {
        this.displayImage = reader.result;
        this.actualEdit.newImage = reader.result;
      };
      reader.onerror = function (error) {
        console.log(error);
      };
    },

    openModalChangePassword() {
      this.modalCustomSize.isButtonsDisabled = true;
      this.modalCustomSize.isOpen = true;
      this.modalCustomSize.isEdit = false;
      this.modalCustomSize.buttonText = "Alterar Senha";
      this.modalCustomSize.formTitle = "Alterar senha";
      this.showNewPasswordInput = false;

      this.senhaAntiga = null;
      this.digitarSenha = null;
      this.digitarSenhaNovamente = null;
      this.newPassword.novaSenha = null;
    },

    fecharModalPassword(){
      this.modalCustomSize.isOpen = false;
      this.modalCustomSize.isButtonsDisabled = true;
    },

    fecharNotificacao() {
      this.mensagemSucesso = false;
    },
  },

  watch: {
    senhaAntiga() {
      this.modalCustomSize.isButtonsDisabled = true;
      this.validatePasswordFromFuncionario(this.senhaAntiga);
    },

    digitarSenhaNovamente() {
      this.modalCustomSize.isButtonsDisabled = true;
      if (this.digitarSenha == this.digitarSenhaNovamente) {
        this.mensagemErro.erro = false;
        this.modalCustomSize.newPassword.novaSenha = this.digitarSenhaNovamente;
        this.modalCustomSize.isButtonsDisabled = false;
      } else {
        this.modalCustomSize.newPassword.novaSenha = null;
        this.modalCustomSize.isButtonsDisabled = true;

        this.mensagemErro.erro = true;
        this.mensagemErro.text = "Ambas as senhas devem ser iguais!";
      }
    },
    digitarSenha(newVal) {
      this.isButtonDisabled = !newVal; // Desativa o botão se 'digitarSenha' for null ou vazio
    },
  },
};
</script>